import { upcomingTripColumns } from '../../../../data/upcomingTrips'
import type { UpcomingTrip } from '../../../../types'
import { UpcomingTripRow } from './UpcomingTripRow'
import {
  UPCOMING_TRIPS_GRID,
  UPCOMING_TRIPS_INSET,
  UPCOMING_TRIPS_MIN_WIDTH,
} from './upcomingTripsLayout'

type UpcomingTripsCardProps = {
  trips: UpcomingTrip[]
}

export const UpcomingTripsCard = ({ trips }: UpcomingTripsCardProps) => (
  <section className="w-full overflow-hidden rounded-[18px] bg-white shadow-[0_1px_6px_rgba(0,0,0,0.04)] xl:w-[794px]">
    <h2 className="px-[31px] pb-[23px] pt-[30px] font-host text-[16px] font-medium leading-normal text-black">
      Upcoming Trips
    </h2>

    {/* Horizontal scroll only when needed */}
    <div className="overflow-x-auto pr-[15px] scrollbar-hide ">
      <div style={{ minWidth: UPCOMING_TRIPS_MIN_WIDTH }}>

        {/* Table heading stays fixed */}
        <div
          className={`grid h-[37px] items-center whitespace-nowrap bg-dash-row-head-bg font-host text-[16px] font-medium leading-normal text-dash-row-head ${UPCOMING_TRIPS_INSET}`}
          style={{ gridTemplateColumns: UPCOMING_TRIPS_GRID }}
        >
          {upcomingTripColumns.map((column) => (
            <span key={column}>{column}</span>
          ))}
        </div>

        {/* ONLY TRIP ROWS SCROLL */}
        <div className="pr-[12px]">
          <div className="flex flex-col gap-[16px] pb-[22px] pt-[16px]">
            {trips.length > 0 ? (
              trips.map((trip) => (
                <UpcomingTripRow
                  key={trip.id}
                  trip={trip}
                />
              ))
            ) : (
              <p className="px-[31px] font-host text-[14px] text-dash-muted">
                No upcoming trips right now.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
)